document.addEventListener('DOMContentLoaded', function () {
  const megaMenus = document.querySelectorAll('.kg-has-mega-menu');

  megaMenus.forEach((menu) => {
    const links = menu.querySelectorAll('.kg-mega-sub-link');
    const image = menu.querySelector('.kg-mega-dynamic-image');
    const title = menu.querySelector('.kg-mega-dynamic-title');
    const count = menu.querySelector('.kg-mega-dynamic-count');
    const category = menu.querySelector('.kg-mega-dynamic-category');
    const button = menu.querySelector('.kg-mega-dynamic-btn');

    if (!image || !title || !count || !category || !button) return;

    const defaultImage = image.src;
    const defaultTitle = title.textContent.trim();
    const defaultCount = count.textContent.trim();
    const defaultCategory = category.textContent.trim();
    const defaultButton = button.href;

    links.forEach((link) => {
      link.addEventListener('mouseenter', function () {
        const newImage = this.dataset.image;
        const newTitle = this.dataset.title;
        const newCount = this.dataset.count;
        const newCategory = this.dataset.category;
        const newUrl = this.href;

        if (newImage && image.src !== newImage) {
          image.style.opacity = '0';

          const preload = new Image();
          preload.src = newImage;
          preload.onload = function () {
            image.src = newImage;
            image.style.opacity = '1';
          };
        }

        if (newTitle) {
          title.textContent = newTitle;
        }

        if (newCount !== undefined && newCount !== '') {
          count.textContent = newCount;
        }

        if (newCategory) {
          category.textContent = newCategory;
        }

        if (newUrl) {
          button.href = newUrl;
        }
      });
    });

    menu.addEventListener('mouseleave', function () {
      image.style.opacity = '1';
      image.src = defaultImage;
      title.textContent = defaultTitle;
      count.textContent = defaultCount;
      category.textContent = defaultCategory;
      button.href = defaultButton;
    });
  });
});
